// extracted by mini-css-extract-plugin
export default {"configOptionSwatchText":"TextSwatch-configOptionSwatchText-3EW"};